export interface AccountSidebarTabInterface {
  title: string
  active: boolean
  onclick: () => void
  dataTestid?: string
}

export const AccountSidebarTab = ({
  title,
  active,
  onclick,
  dataTestid,
}: AccountSidebarTabInterface): JSX.Element => {
  return (
    <div
      className={`account-sidebar-tab my-3 ${active ? 'active' : ''}`}
      onClick={onclick}
      style={{ cursor: 'pointer' }}
      data-testid={dataTestid ?? title}
    >
      <h6>{title}</h6>
    </div>
  )
}
